import _classCallCheck from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/helpers/esm/inherits";
import Transport from "winston-transport";
import { LogLevel } from "@timberio/types";
export var TimberTransport =
/*#__PURE__*/
function (_Transport) {
  _inherits(TimberTransport, _Transport);

  function TimberTransport(_timber) {
    var _this;

    _classCallCheck(this, TimberTransport);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimberTransport).call(this));
    _this._timber = _timber;
    return _this;
  }

  _createClass(TimberTransport, [{
    key: "log",
    value: function log(info, cb) {
      var _this2 = this;

      // Pass the log to Winston's internal event handlers
      setImmediate(function () {
        _this2.emit("logged", info);
      }); // Determine the log level

      var level;

      switch (info.level) {
        case "debug":
          level = LogLevel.Debug;
          break;

        case "warn":
          level = LogLevel.Warn;
          break;

        case "error":
          level = LogLevel.Error;
          break;
        // All other log levels use `Info` by default

        default:
          level = LogLevel.Info;
      } // Log out to Timber


      void this._timber.log(info.message, level); // Winston callback...

      cb();
    }
  }]);

  return TimberTransport;
}(Transport);